import { ConfigurationService } from '@app/app-initialisers/configuration-service/configuration.service';

export const ConfigurationInit = (configurationService: ConfigurationService) => () => configurationService.loadConfiguration();
